import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/Layout'

Vue.use(Router)

export default new Router({
  // 滚动行为
  scrollBehavior: () => ({
    y: 0
  }),
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login')
  },
  { // Always leave this as last one
    path: '*',
    component: () => import('@/views/404')
  },
  {
    path: '/',
    component: Layout,
    children: [{
      path: '/index',
      name: 'index',
      meta: {title: '个人主页'},
      component: () =>
      import('@/views/index')
    },
    // ================系统设置===============
    // 人员角色管理
    {
      path: '/personalRole',
      name: 'personalRole',
      meta: {title: '人员角色管理'},
      component: () =>
      import('@/views/systemSettings/personalRole/personalRole')
    },
    // 角色权限
    {
      path: '/rolePermission',
      name: 'rolePermission',
      meta: {title: '角色权限'},
      component: () =>
      import('@/views/systemSettings/rolePermission/rolePermission')
    },
    // 行政组织
    {
      path: '/administrativeOrg',
      name: 'administrativeOrg',
      meta: {title: '行政组织'},
      component: () =>
      import('@/views/systemSettings/administrativeOrg/administrativeOrg')
    },
    // 业务组织
    {
      path: '/businessOrg',
      name: 'businessOrg',
      meta: {title: '业务组织'},
      component: () =>
      import('@/views/systemSettings/businessOrg/businessOrg')
    },
    // 数据同步
    {
      path: '/dataSynchronism',
      name: 'dataSynchronism',
      meta: {title: '数据同步'},
      component: () =>
      import('@/views/systemSettings/dataSynchronism/dataSynchronism')
    },
    // 功能管理--列表
    {
      path: '/functionManagement',
      name: 'functionManagement',
      meta: {title: '功能管理'},
      component: () =>
      import('@/views/systemSettings/functionManagement/functionManagement')
    },
    // 功能管理--新增
    {
      path: '/functionManagementEdite',
      name: 'functionManagementEdite',
      meta: {title: '功能管理'},
      component: () =>
      import('@/views/systemSettings/functionManagement/functionManagementEdite')
    },
    // 权限分配--列表
    {
      path: '/permissionAllocation',
      name: 'permissionAllocation',
      meta: {title: '权限分配'},
      component: () =>
      import('@/views/systemSettings/permissionAllocation/permissionAllocation')
    },
    // 权限分配--编辑
    {
      path: '/permissionAllocationEdite',
      name: 'permissionAllocationEdite',
      meta: {title: '权限分配-编辑'},
      component: () =>
      import('@/views/systemSettings/permissionAllocation/permissionAllocationEdite')
    },
      // 权限分配--信息分配管理
    {
      path: '/inforDistributionManagement',
      name: 'inforDistributionManagement',
      meta: {title: '信息分配管理'},
      component: () =>
          import('@/views/systemSettings/inforDistributionManagement/inforDistributionManagement')
    },
    // 权限分配--信息分配管理
    {
      path: '/solidification',
      name: 'solidification',
      meta: {title: '数据固化'},
      component: () =>
            import('@/views/systemSettings/solidification/solidification')
    },
    // =========================渠道管理===================
    // 渠道信息
    {
      path: '/channelInformation',
      name: 'channelInformation',
      meta: {title: '渠道信息'},
      component: () =>
      import('@/views/channelManagement/channelInformation/channelInformation')
    },
    // 渠道账号
    {
      path: '/channelAccount',
      name: 'channelAccount',
      meta: {title: '渠道账号'},
      component: () =>
      import('@/views/channelManagement/channelAccount/channelAccount')
    },
    // =========================机会学员流程管理===================
    // 机会学员录入/导入
    {
      path: '/informationCollection',
      name: 'informationCollection',
      meta: {title: '机会学员录入'},
      component: () =>
      import('@/views/recruitStudent/informationCollection/informationCollection')
    },
    // 电销沟通记录
    {
      path: '/telephoneCommunication',
      name: 'telephoneCommunication',
      meta: {title: '电销沟通记录'},
      component: () =>
      import('@/views/recruitStudent/telephoneCommunication/telephoneCommunication')
    },
    // 顾问面访记录
    {
      path: '/counselorInterview',
      name: 'counselorInterview',
      meta: {title: '顾问面访记录'},
      component: () =>
      import('@/views/recruitStudent/counselorInterview/counselorInterview')
    },
    // 学员到访
    {
      path: '/studentVisit',
      name: 'studentVisit',
      meta: {title: '学员到访'},
      component: () =>
      import('@/views/recruitStudent/studentVisit/studentVisit')
    },
    // 到访计划
    {
      path: '/visitPlan',
      name: 'visitPlan',
      meta: {title: '到访计划'},
      component: () =>
      import('@/views/recruitStudent/visitPlan/visitPlan')
    },
    // 缴费跟踪
    {
      path: '/paymenttracking',
      name: 'paymenttracking',
      meta: {title: '缴费跟踪'},
      component: () =>
      import('@/views/recruitStudent/PaymentTracking/paymenttracking')
    },
    // 学员查找
    {
      path: '/studentquery',
      name: 'studentquery',
      meta: {title: '学员查找'},
      component: () =>
      import('@/views/recruitStudent/studentQuery/studentquery')
    },
      // 学员高级查找
    {
      path: '/advancedStudentQuery',
      name: 'advancedStudentQuery',
      meta: {title: '高级学员查找'},
      component: () =>
          import('@/views/recruitStudent/advancedStudentQuery/advancedStudentQuery')
    },
    // =========================数据统计===================
    // 业务统计
    {
      path: '/businessStatistics',
      name: 'businessStatistics',
      meta: {title: '业务统计'},
      component: () =>
      import('@/views/dataStatistics/businessStatistics/businessStatistics')
    },
    // 渠道统计
    {
      path: '/channelStatistics',
      name: 'channelStatistics',
      meta: {title: '渠道统计'},
      component: () =>
      import('@/views/dataStatistics/channelStatistics/channelStatistics')
    },
    // 已缴费信息
    {
      path: '/payMessage',
      name: 'payMessage',
      meta: {title: '已缴费信息'},
      component: () =>
      import('@/views/dataStatistics/payMessage/payMessage')
    }
    ]
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js